<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span>Update Help</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="helpForm" (submit)="createhelp()">
                <div class="card-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12 col-lg-12">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="form-label">Description: </label>
                                        <ckeditor [editor]="Editor" formControlName="description"
                                            (ready)="onReady($event)"></ckeditor>
                                    </div>
                                    <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
                                        <div *ngIf="f.description.errors.required">Description is required</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                            class="fa fa-spin fa-spinner"></i>
                        <span *ngIf="helpId">Update Help</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>